import React, { useEffect, useState } from "react";
import api from "../services/api";
import Header from "../components/Header";
import { useAuth } from "../context/AuthContext";
import { Button, Card, Tag, brl, dataBR, dataHoraBR } from "../components/ui";

/** Rótulo/tom do status da assinatura */
function tomStatus(s) {
    if (s === "ativa") return "success";
    if (s === "pendente") return "warn";
    return "danger";
}
function rotuloStatus(s) {
    return s === "pendente" ? "aguardando assinatura" : s;
}
/** Tom do status de uma cobrança do Mercado Pago */
function tomCobranca(s) {
    if (s === "approved") return "success";
    if (s === "pending" || s === "in_process") return "warn";
    return "danger";
}

const Assinatura = () => {
    const { ehProprietario } = useAuth();
    const [plano, setPlano] = useState(null);
    const [erro, setErro] = useState(null);
    const [indoParaCartao, setIndoParaCartao] = useState(false);
    const [pix, setPix] = useState(null);
    const [gerandoPix, setGerandoPix] = useState(false);
    const [copiado, setCopiado] = useState(false);

    useEffect(() => {
        api.get("/assinatura")
            .then((r) => setPlano(r.data))
            .catch(() => setErro("Não foi possível carregar o plano."));
    }, []);

    const assinarCartao = async () => {
        setIndoParaCartao(true);
        setErro(null);
        try {
            const { data } = await api.post("/assinatura/assinar");
            if (data.init_point) window.location.href = data.init_point;
            else setIndoParaCartao(false);
        } catch (err) {
            setErro(err.response?.data?.error || "Não foi possível iniciar a assinatura.");
            setIndoParaCartao(false);
        }
    };

    const pagarPix = async () => {
        setGerandoPix(true);
        setErro(null);
        setPix(null);
        try {
            const { data } = await api.post("/assinatura/pix");
            setPix(data);
        } catch (err) {
            setErro(err.response?.data?.error || "Não foi possível gerar o PIX.");
        } finally {
            setGerandoPix(false);
        }
    };

    const copiar = async () => {
        try {
            await navigator.clipboard.writeText(pix.qr_code);
            setCopiado(true);
            setTimeout(() => setCopiado(false), 2500);
        } catch { /* clipboard indisponível */ }
    };

    const a = plano?.assinatura;

    return (
        <div>
            <Header />
            <main className="page">
                <h2 style={{ margin: 0 }}>Plano / Assinatura</h2>
                <p className="text-muted" style={{ margin: "4px 0 0" }}>
                    Mensalidade do Selo Jurídico para o seu escritório.
                </p>

                {erro && <p className="erro">{erro}</p>}

                {!plano ? (
                    <p className="text-muted">Carregando...</p>
                ) : !a ? (
                    <Card>
                        <p className="card-body text-muted" style={{ margin: 0 }}>
                            A Selo Systems ainda não definiu a mensalidade deste escritório.
                            Assim que definir, você poderá pagar por aqui (cartão ou PIX).
                        </p>
                    </Card>
                ) : (
                    <>
                        <Card>
                            <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                                <span style={{ fontSize: 30, fontFamily: "var(--font-heading)", fontWeight: 800 }}>
                                    {brl(a.valor_mensal)}
                                </span>
                                <span className="text-muted">/ mês</span>
                                <Tag tom={tomStatus(a.status)}>{rotuloStatus(a.status)}</Tag>
                            </div>

                            {a.data_vencimento && (
                                a.vencida ? (
                                    <p style={{ margin: "8px 0 0", color: "#a32b1d", fontWeight: 600 }}>
                                        ⚠ Vencida em {dataBR(a.data_vencimento)}
                                        {typeof a.dias_para_vencer === "number" && ` (há ${Math.abs(a.dias_para_vencer)} dia${Math.abs(a.dias_para_vencer) === 1 ? "" : "s"})`}
                                        {" "}— pode ser cancelada a qualquer momento.
                                    </p>
                                ) : (
                                    <p className="text-muted" style={{ margin: "8px 0 0" }}>
                                        Vence em <strong>{a.dias_para_vencer} dia{a.dias_para_vencer === 1 ? "" : "s"}</strong> ({dataBR(a.data_vencimento)}).
                                    </p>
                                )
                            )}

                            {!ehProprietario ? (
                                <p className="text-muted" style={{ marginTop: 10 }}>
                                    Só o proprietário do escritório pode gerenciar o pagamento.
                                </p>
                            ) : (
                                <>
                                    <p className="card-body" style={{ marginTop: 10, marginBottom: 6 }}>
                                        Escolha como pagar:
                                    </p>
                                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                        <Button onClick={assinarCartao} disabled={indoParaCartao || !plano.configurado || a.status === "ativa"}>
                                            {indoParaCartao ? "Redirecionando..." : "Assinar com cartão (automático)"}
                                        </Button>
                                        <Button variante="secondary" onClick={pagarPix} disabled={gerandoPix || !plano.configurado}>
                                            {gerandoPix ? "Gerando PIX..." : "Pagar com PIX (este mês)"}
                                        </Button>
                                    </div>
                                    {!plano.configurado && (
                                        <p className="text-muted" style={{ fontSize: 13, marginTop: 8 }}>
                                            Pagamento em configuração pela Selo Systems. Tente novamente em breve.
                                        </p>
                                    )}
                                    <p className="text-muted" style={{ fontSize: 13, marginTop: 8 }}>
                                        <strong>Cartão:</strong> cobrança mensal automática. <strong>PIX:</strong> você paga o mês atual e repete quando quiser.
                                    </p>
                                </>
                            )}
                        </Card>

                        {pix && (
                            <Card>
                                <h3 className="card-title">Pague com PIX</h3>
                                <p className="card-body text-muted" style={{ marginTop: 0 }}>
                                    Escaneie o QR code no app do seu banco ou use o "copia e cola" abaixo.
                                </p>
                                <div style={{ display: "flex", gap: 20, flexWrap: "wrap", alignItems: "flex-start" }}>
                                    {pix.qr_code_base64 && (
                                        <img
                                            src={`data:image/png;base64,${pix.qr_code_base64}`}
                                            alt="QR code do PIX"
                                            style={{ width: 200, height: 200, border: "1px solid var(--color-divider)", borderRadius: "var(--radius-md)", background: "#fff" }}
                                        />
                                    )}
                                    <div style={{ flex: 1, minWidth: 240 }}>
                                        <label className="card-kicker">PIX copia e cola</label>
                                        <textarea
                                            readOnly
                                            value={pix.qr_code || ""}
                                            onFocus={(e) => e.target.select()}
                                            className="input"
                                            style={{ width: "100%", minHeight: 90, fontFamily: "monospace", fontSize: 12, marginTop: 4 }}
                                        />
                                        <Button onClick={copiar} style={{ marginTop: 8 }}>
                                            {copiado ? "Copiado!" : "Copiar código"}
                                        </Button>
                                        <p className="text-muted" style={{ fontSize: 13, marginTop: 8 }}>
                                            Após o pagamento, a confirmação aparece no histórico automaticamente (pode levar alguns instantes).
                                        </p>
                                    </div>
                                </div>
                            </Card>
                        )}

                        {plano.cobrancas.length > 0 && (
                            <Card>
                                <h3 className="card-title">Histórico de cobranças</h3>
                                <ul className="mini-lista">
                                    {plano.cobrancas.map((c) => (
                                        <li key={c.cod_cobranca}>
                                            <Tag tom={tomCobranca(c.status)}>
                                                {c.status === "approved" ? "aprovado" : c.status === "pending" ? "pendente" : c.status}
                                            </Tag>
                                            {c.valor != null && <span>{brl(c.valor)}</span>}
                                            <span className="text-muted" style={{ marginLeft: "auto" }}>
                                                {dataHoraBR(c.data_pagamento || c.criado_em)}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            </Card>
                        )}
                    </>
                )}
            </main>
        </div>
    );
};

export default Assinatura;
